<template>
  <div class="social-subcomment  list-complete-item">
    <div class="sub-comment-header">
      <i class="social-comment-icon"></i>
      <img :src="$imageus + (subComment.owner.image == null ? host + '/static/500x500-user.png' : subComment.owner.image) + '?width=200&height=200&mode=cover'" @click="openUserModal(subComment)" alt="" />

      <div class="comment-user-title" @click="openUserModal(subComment)">
        <span class="comment-user-title-text">{{ subComment.owner.fullName }}</span>
        <span class="time">{{ moment(subComment.createDate).fromNow() }}</span>
      </div>
      <div class="comment-owner">
        <el-dropdown v-if="subComment.owner != null && subComment.owner.id == currentUser.id">
          <span class="el-dropdown-link"><i class="fas fa-ellipsis-v"></i> </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item icon="fas fa-trash" @click.native="deleteComment(subComment.id)">{{ $t("socialhub.deleteComment") }}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <div class="sub-comment-body">
      <div class="sub-comment-text">
        <span v-html="parseUrl(subComment.commentText, subComment)"></span>
      </div>
      <div class="comment-buttons">
        <span class="comment-reply" :style="{ color: newComment ? '#FF6565' : '#292F3B' }" @click="replyComment">{{ newComment ? $t("socialhub.cancel") : $t("socialhub.reply") }}</span>
        <!-- <div class="like-area">
          <span>{{ subComment.likeCount }} Beğeni</span>
          <i class="hearth-icon" :class="{ active: this.subComment.isLiked }" @click="toggleLikeComment"></i>
        </div> -->
        <div class="like-area" @click="toggleLikeComment">
          <span v-if="subComment.likeCount > 0">{{ subComment.likeCount }}</span>
          <i class="el-icon-loading" v-if="loading == 'commentLike'"></i>
          <i :class="subComment.isLiked ? 'fa fa-heart active' : 'far fa-heart'" v-else></i>
        </div>
      </div>
      <transition name="el-zoom-in-top" mode="out-in">
        <div class="send-sub-comment" v-if="newComment" :key="'new-comment-area-' + subComment.id + '-key-' + newComment" @keyup.enter.exact="postComment()">
          <div v-if="isCommentMentionVisible" v-dragscroll.x class="mention-panel">
            <div v-for="(user, index) in users" :key="index" @click="tagUser(user, commentForm)" class="mention-item">
              <div :style="user.image == null ? 'background-color: f1f1f1;' : 'background-image: url(' + $imageus + user.image + '?width=200&height=200&mode=cover&background=ffffff'" class="user-image"></div>
              <p v-if="user.type == 2">{{ user.title }}</p>
              <p else>{{ user.fullName }}</p>
            </div>
          </div>
          <el-input v-model="commentForm.commentText" resize="auto" class="comment-input" @input="commentMention(commentForm)">
            <template slot="suffix">
              <i class="el-input__icon fas " :class="loading == 'postCommentLoading' ? 'el-icon-loading' : 'fa-paper-plane'" @click="postComment()"></i>
            </template>
          </el-input>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment/min/moment-with-locales";
import { dragscroll } from "vue-dragscroll";

export default {
  props: ["subComment"],
  directives: {
    dragscroll
  },
  data() {
    return {
      users: [],
      isCommentMentionVisible: false,
      host: location.host == "localhost:3000" ? "https://live.holacon.com/" : "https://" + location.host,
      commentForm: {
        id: null,
        postId: this.subComment.postId,
        commentText: null,
        parentId: this.subComment.parentId,
        mentions: []
      },
      loading: false,
      timeout: null,
      searchTerm: null,
      newComment: false,
      axios,
      moment
    };
  },
  computed: {
    currentUser() {
      return this.$store.getters.getUser;
    }
  },
  methods: {
    openUserModal(post) {
      if (post.owner.id != null) {
        this.$root.$emit("getProfile", post.owner.id);
      }
    },
    async deleteComment(id) {
      await this.$store.dispatch("deleteComment", id);
    },
    replyComment() {
      var fIndex = this.commentForm.mentions.findIndex(x => x.id == this.subComment.owner.id);
      if (fIndex == -1) {
        this.commentForm.mentions.push(this.subComment.owner);
        this.commentForm.commentText = this.subComment.owner.fullName + " ";
      } else {
        this.commentForm.commentText = this.subComment.owner.fullName + " ";
      }
      this.newComment = !this.newComment;
    },
    postComment() {
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        var commentTitle = this.commentForm.commentText;
        this.commentForm.mentions.forEach(user => {
          commentTitle = commentTitle.replace(user.fullName, "%" + user.id + "%");
        });
        var res = await axios.post("socialhub/addupdatecomment", {
          id: null,
          parentId: this.subComment.parentId,
          postId: this.subComment.postId,
          commentText: commentTitle != "" ? commentTitle : this.commentForm.commentText,
          mentions: this.commentForm.mentions
        });
        if (res.data.hasError == true) {
          this.$message.error(res.data.message);
        } else {
          this.commentForm.commentText = null;
          this.users = [];
        }
        this.newComment = false;
        this.loading = false;
      }, 500);
    },
    commentMention(post) {
      if (this.commentForm.commentText != "" && this.commentForm.commentText != null) {
        this.commentForm.commentText.split(" ").forEach(item => {
          if (item.startsWith("@")) {
            this.users = [];
            this.isCommentMentionVisible = true;
            this.searchTerm = item.replace("@", "");
            setTimeout(() => {
              axios
                .post("socialhub/searchmention", {
                  searchTerm: this.searchTerm
                })
                .then(res => {
                  this.users = res.data.data.items;
                });
            }, 1000);
          } else {
            this.isCommentMentionVisible = false;
            this.searchTerm = "";
          }
        });
      }
    },
    tagUser(user, post) {
      this.isCommentMentionVisible = false;
      this.commentForm.commentText = this.commentForm.commentText.replaceAll("@" + this.searchTerm, user.fullName);
      this.commentForm.mentions.push(user);
      this.users = [];
      this.searchTerm = "";
    },
    async toggleLikeComment() {
      this.loading = "commentLike";
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        var payload = {
          id: this.subComment.id,
          postId: this.subComment.postId,
          isLiked: !this.subComment.isLiked
        };
        var res = await this.$store.dispatch("toggleLikeComment", payload);
        if (!res.data.hasError) {
          this.subComment.isLiked = !this.subComment.isLiked;
        }
        this.loading = false;
      }, 500);
    },
    parseUrl(text, post) {
      var urlRegex = /(https?:\/\/[^\s]+)/g;
      var usernameRegex = /\%(.*?)\%/g;
      if (text == null) return;
      text = text.replace(urlRegex, function(url) {
        return '<a href="' + url + '" target="_blank">' + url + "</a>";
      });
      post.mentions.forEach(user => {
        if (text.includes("%" + user.id + "%")) {
          text = text.replace("%" + user.id + "%", '<a href="javascript:;" user-id="' + user.id + '" class="open-user">@' + user.fullName + "</a>");
        }
      });
      return text;
    }
  }
};
</script>

<style lang="less">
.social-subcomment {
  padding: 10px 0px 10px 0;
  margin-right: 0px;
  max-width: 100%;
  border-top: 0.5px solid rgba(200, 205, 211, 0.4);
  margin-bottom: 1rem;
  display: flex;
  flex-direction: column;
  width: 100%;
  &:last-child {
    margin-bottom: 0;
  }
  gap: 10px;
  .sub-comment-header {
    display: flex;
    align-items: center;
    gap: 8px;
    img {
      cursor: pointer;
      user-select: none;
      width: 32px;
      height: 32px;
      border-radius: 50%;
      border: 2px solid #e8ebef;
      object-fit: cover;
    }
    .comment-user-title  {
      cursor: pointer;
      user-select: none;
      display: flex;
      flex-direction: column;
      font-weight: 700;
      font-size: 14px;
      line-height: 20px;
      color: #000000;
      .time {
        font-weight: 400;
        font-size: 12px;
        line-height: 18px;
        letter-spacing: 0.2px;
        color: #8c929c;
      }
    }
    .comment-owner {
      margin-left: auto;
    }
  }
  .sub-comment-body {
    padding-left: 32px;
    display: flex;
    flex-direction: column;
    gap: 1rem;
    .sub-comment-text {
      span {
        word-wrap: break-word;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/event/socialHub/SubComment.vue